import { Checkbox, InputLabel } from "@mui/material";
import Stack from "@mui/material/Stack";

const CheckBoxFieldEmailTransaction = ({ label, name, value, onChange, ...props }) => {
  return (
    <Stack flex={1} direction="row" className="modal-stack">
      <InputLabel className="flex-2">{label}</InputLabel>
      <Checkbox
        name={name}
        className="flex-6"
        color="primary"
        value={value}
        checked={Boolean(value)}
        onChange={(e) => onChange(e)}
        sx={{ justifyContent: "flex-start", paddingLeft: 0 }}
        {...props} // this is okay as long as you don't pass 'key' here
      />
    </Stack>
  );
};

export default CheckBoxFieldEmailTransaction;
